export type FormErrorValues<TValues> = Partial<Record<keyof TValues, string | undefined>>;

export function hasErrors<TValues>(errors: FormErrorValues<TValues>): boolean {
    return Object.values(errors).some((error) => typeof error === "string" && error.length > 0);
}